import { useEffect, useState } from 'react';
import GoogleMapReact from 'google-map-react';
import { LocationOnIcon } from 'components/icons';
import styles from './PlaceMap.module.css';
import { object } from 'prop-types';

/**
 * @component PlaceMap
 * @param {Object} props
 * @param {Object} props.coordinate
 * @param {string} props.coordinate.lat
 * @param {string} props.coordinate.lng
 * @returns {JSX.Element}
 */
function PlaceMap({ coordinate }) {
	const [parseCoordinate, setParseCoordinate] = useState({ lat: 51.049999, lng: -114.066666 });

	const options = (maps) => {
		return {
			fullscreenControl: true,
			zoomControl: true,
			zoomControlOptions: {
				position: maps.ControlPosition.RIGHT_BOTTOM,
				style: maps.ZoomControlStyle.SMALL,
			},
			mapTypeControlOptions: {
				position: maps.ControlPosition.TOP_LEFT,
			},
			mapTypeControl: true,
			streetViewControl: true,
		};
	};

	useEffect(() => {
		const makeCoordinate = () => {
			if (coordinate?.lat !== '' && coordinate.lng !== '') {
				const _coordinate = {
					lat: parseFloat(coordinate.lat),
					lng: parseFloat(coordinate.lng),
				};
				setParseCoordinate(_coordinate);
			}
		};
		makeCoordinate();
	}, [coordinate]);

	return (
		<GoogleMapReact
			bootstrapURLKeys={{ key: process.env.VITE_GOOGLE_API_KEY }}
			zoom={15}
			options={options}
			center={parseCoordinate}
		>
			<LocationOnIcon
				className={styles.location_icon}
				lat={parseCoordinate.lat}
				lng={parseCoordinate.lng}
			/>
		</GoogleMapReact>
	);
}

PlaceMap.propTypes = { coordinate: object };

export default PlaceMap;
